// extracted by mini-css-extract-plugin
export default {"Box":"ChecksStatusBadgeFooter-module__Box--H_aiQ"};